/* global UA */
import get from 'lodash/get';
import { getQueryParam } from '@client/helpers/getQueryParam';

export const getFromSdk = async(properties, defaultResult) => {
    try {
        const sdk = await window.UA;
        const result = typeof defaultResult !== 'undefined' ? defaultResult : null;

        return !properties ? sdk : get(sdk, properties, result);
    }
    catch (e) {
        // eslint-disable-next-line no-console
        console.error('error', e);

        return false;
    }
};

export const getExternalCartStatus = () => {
    if (typeof window === 'undefined') {
        return null;
    }

    return getQueryParam(window.location.search, 'cartOverlay');
};
